import { Box, IconButton, Typography } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { TLabelModalDashboard, TModalDashboard } from "../..";
import truncarString from "../../../../../../../helpers/truncarString";
import { TConfigBancariasSemIntegracao } from "../../../../../../../types/api/financeiro/configuracoes-bancarias";
export default function TableRowConfigs({
    handleModalAction,
    label,
    modal,
    integracao,
    handleOpenModalPrimeiraConfig
}: TableRowConfigsProps) {

    return (
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Typography>Config. padrão para {label}:</Typography>
                <Box display={'flex'} alignItems={'center'} gap={1}>
                    {
                        integracao &&
                        <Typography fontWeight="bold">
                            {integracao ? `${truncarString(integracao.nome_banco, 15)} - Ag: ${integracao.agencia} / Conta: ${integracao.conta}` : 'Não configurado'}
                        </Typography>
                    }
                    {
                        !integracao &&
                        <Typography fontWeight={'bold'}>Não configurado</Typography>
                    }
                    <IconButton
                        aria-label="edit"
                        size="small" sx={{ mb: 0.5 }}
                        onClick={() => integracao ? handleModalAction('open', label, modal, integracao) : handleOpenModalPrimeiraConfig(true, modal)}
                        >
                        <EditIcon />
                    </IconButton>
                </Box>
            </Box>
    )
}

interface TableRowConfigsProps {
    handleModalAction: (action: "open" | "close", label: TLabelModalDashboard, modal: TModalDashboard, value: TConfigBancariasSemIntegracao) => void
    label: TLabelModalDashboard
    modal: TModalDashboard
    integracao: TConfigBancariasSemIntegracao
    handleOpenModalPrimeiraConfig: (action: boolean, modal:TModalDashboard) => void
}
